import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useWatch } from 'react-hook-form';

import { useContactInfo } from 'reservations/account/providers/ConfigProvider';
import { getMaxPartySizeText } from 'reservations/availabilities/helpers/getMaxPartySizeText';

export const MaxPartySizeText = () => {
  const { emailAddress, phoneNumber } = useContactInfo();
  const partySize = useWatch({
    name: 'partySize'
  });
  const { message, LinkComponent } = getMaxPartySizeText(
    emailAddress,
    phoneNumber,
    partySize
  );

  return (
    <Box sx={{ p: '16px' }}>
      <Typography
        data-testid="max-party-size-text"
        sx={theme => ({
          color: theme.palette.soy.dark,
          fontSize: '16px',
          textAlign: 'center'
        })}
      >
        {message}
        {LinkComponent}
      </Typography>
    </Box>
  );
};
